/* eslint-disable */

(function($) {

  'use strict';

  function Filter() {

    var self = this,
      $el = null,

      options = {
        'example': null
      };

      // init Isotope
      var $productList = null;
      //****************************
      // Isotope Load more button
      //****************************
      var initShow = 6; //number of images loaded on init & onclick load more button
      var counter = 0; //counter for load more button
      var iso = null; // get Isotope instance

    /**
     * Set Grid Item Height
     */
    function resizeGridItem(row, rowHeight) {
      $.each(row, function( index, $el ) {
        //Set Row height
        $el.height(rowHeight);
      });
    }

    /**
     * Set Grid Col Border
     */
    function setColBorder(row, itemByRow) {
      $.each(row, function( index, $el ) {
        var pos  = index+1;

        //Remove old classes
        $el.removeClass('js-border js-no-border');

        if(pos == itemByRow) {
          //Last Item = no border
          $el.addClass('js-no-border');
        } else {
          //Not Last Item = border
          $el.addClass('js-border');
        }
      });
    }

    /**
     * Resize Grid
     */
    function resizeGrid() {
      var $products = $('#productList .product');
      var itemByRow = 3;
      var rowHeight = 0;
      var row = [];

      if($(window).width() < 992 ) { itemByRow = 2; }

      if($(window).width() < 576 ) { itemByRow = 1; }

      $products.filter(':visible').each(function(index) {
        var $el = $(this);
        if($el.css('opacity') != '0') {
          var h = $el.css('height','auto').height();

          row.push($el);

          if(h > rowHeight) rowHeight = h;

          if((row.length == itemByRow || $products.length == index+1)) {

            if(itemByRow > 1) {
              //Resize row
              resizeGridItem(row, rowHeight);
            }
            
            setColBorder(row, itemByRow);

            //Reset
            row = [];
            rowHeight = 0;
          }
        }
      });

      $('#productList').isotope().isotope('layout');
    }

    /**
     * Generic resize
     */
    function onResize() {
      // Example
      if (window.bp.getLastValue() !== window.bp.getValue()) {
        resizeGrid();
      }
    }

    function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;
  
      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');
  
          if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
      }
    };

    function setSelect(){
      var filter = $('#filtre-cat').data('filter');
      var categorie = getUrlParameter(filter);
      if(categorie && $('#filtre-cat').find("option[value='" + categorie + "']").length){
        $('#filtre-cat').val(categorie);
        $('#filtre-cat').trigger('change');
      } else {
        console.log('no cat');
      }

      var type = getUrlParameter('type');
      if(type && $('#filtre-type').find("option[value='" + type + "']").length){
        $('#filtre-type').val(type);
        $('#filtre-type').trigger('change');
      } else {
        console.log('no type');
      }
    };


    function onSelect() {
      var selectedCategory = '';
      var selectedType = '';

      $('#filtersSection .bd_filter').on('select2:select', function (e) {
        e.preventDefault();
        // var id = e.params.data.id;
        var parentId = $(this).attr('id');

        // console.log(parentId)
        if(parentId == "filtre-cat"){
          $('#filtre-type option[value=-1]').prop('selected',true);
          
          $('#filtre-type').select2({
            minimumResultsForSearch: -1
          });
        }
        
        if($('#filtre-cat').val() == -1){
          // console.log('hide type filter');
          $productList.isotope({filter: '*'});
          selectedCategory = selectedType = '';
          $('#filtre-type').closest('.filter-col').hide();
        }
        else {
          // console.log('hide type filter');
            $('#filtre-type').closest('.filter-col').show();
 
            selectedCategory = ".productCategory-" + $('#filtre-cat').val();

            if($('#filtre-type').val() != -1){
              selectedType = ".productType-" + $('#filtre-type').val();
            }

            $productList.isotope({filter: selectedCategory + selectedType})  
        }

        $productList.isotope('on', 'arrangeComplete', onArrangeComplete(selectedCategory,  selectedType ) );
        
        $productList.isotope('layout');      
        loadMoreProducts(initShow);

        selectedCategory = selectedType = '';

      }) 
    }

    function initIsotopeLayout(){
      $productList = $('#productList').isotope({
        itemSelector: '.product',
        layoutMode: 'fitRows',
        resizable: false, // disable normal resizing
      })

      initShow = 6; 
      counter = initShow; 
      iso = $productList.data('isotope'); 

      loadMoreProducts(counter);

      //append load more button
      var loadMoreLabel = $('#loadMore').attr('name');

      if($productList.isotope('getItemElements').length >= initShow){
          $productList.after('<div class="row justify-content-center"><button id="load-more" class="button">' + loadMoreLabel + '</button></div>');          
          initLoadMoreButtonAction();
      }

      // Display all product on click
      $('#displayAllProducts').on('click', function(e){displayAllProducts()});
    }

    function onArrangeComplete( selectedCategory, selectedType ) {
      // console.log(filteredItems);

      // oposite filter
      // var $opositeFilter = $('#filtersSection select:not(#'+ parentId +')');
      var $opositeFilter = $('#filtersSection #filtre-type');
      var $opositeFilterOptions = $opositeFilter.find('option');

      // console.log($opositeFilter);
      if(selectedCategory != '' && selectedType != ''){
        $('#filtersSection select options:disabled').each(function(){
          $(this).removeAttr('disabled');
          $(this).closest('select').select2({
            minimumResultsForSearch: -1
          });
        });
      }
      else {
        $opositeFilterOptions.each(function(){
          // If selected value is the default
          if ($(this).val() == -1) return;

          var fltOption = '.' + $opositeFilter.data('filter') + '-' + $(this).val();

          // Check all product with the current category 
          if( $productList.find(selectedCategory + fltOption).length == 0){
            // console.log('Should disable');
            $(this).find('.select2-results__option').hide();
            $(this).attr("disabled", "disabled");
            // Reload select
            $opositeFilter.select2({
              minimumResultsForSearch: -1
            });
          }
          else{
            // If :disabled remove attribute from element
            if( $(this).is(":disabled") ){
              $(this).show();
              $(this).removeAttr("disabled");
              // Reload select
              $opositeFilter.select2({
                minimumResultsForSearch: -1
              });
            };
          }
        });
      }

      
      setFilterTypeDisplay();
      
      // resizeGrid();

      setTimeout(resizeGrid, 900);
    }

    function setFilterTypeDisplay(){
      
      var newArray = iso.filteredItems.filter(function(x){
        // console.dir(x.element.attributes[1].value);
        return x.element.attributes[1].value == 1;
      })

      var $filterTypes = $('#filtre-type').closest('.filter-col');
      if(newArray.length == 0){
        $filterTypes.css('visibility', 'hidden');
      }
      else{
        $filterTypes.css('visibility', 'visible');
      }

    }

    function initLoadMoreButtonAction(){
      //when load more button clicked
      $("#load-more").click(function() {
        if ($('.bd_filter').data('clicked')) {
          //when filter button clicked, set initial value for counter
          counter = initShow;
          $('.bd_filter').data('clicked', false);
        } else {
          counter = counter;
        };

        counter = counter + initShow;

        loadMoreProducts(counter);
      });
    }

    function loadMoreProducts(toShow) {
      $productList.find(".hidden").removeClass("hidden");

      var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
        return item.element;
      });
      $(hiddenElems).addClass('hidden');
      
      //when no more to load, hide show more button
      if (hiddenElems.length == 0) {
        $("#load-more").hide();
      } 
      else {
        $("#load-more").show();
      };

      // Reload isotope layout
      $productList.isotope('layout');
    }

    function displayAllProducts(){
      $productList.isotope({filter: '*'});
      initShow = $productList.isotope('getItemElements').length;
      loadMoreProducts(initShow);
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      //extends options
      for (var i in opts) { options[i] = opts[i]; }

      // Caching
      $el = options.$el;


      $('#productList').imagesLoaded( function() {
        onResize();
        // Isotope init
        initIsotopeLayout();
      });

      // Filters selects
      setSelect();
      onSelect();

      //*************
      window.cache.$window.on('resize', onResize);
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.Filter = Filter;

}(jQuery));
